import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "kt_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatError(detail) {
  if (detail == null) return "Terjadi kesalahan, coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };

/**
 * Safely coerce any response payload into an array.
 * Guards against production issues where the backend URL misconfiguration
 * causes non-JSON (HTML error pages) or object responses to leak into
 * components that expect list arrays.
 */
export function asArray(data) {
  if (Array.isArray(data)) return data;
  return [];
}
